export class ReportExportError extends Error {
  constructor(message, { status = 0, code = "exporter_failure", kind = "runtime" } = {}) {
    super(message);
    this.name = "ReportExportError";
    this.status = status;
    this.code = code;
    this.kind = kind;
  }
}

function getFilenameFromDisposition(disposition) {
  const value = String(disposition || "");
  const quoted = value.match(/filename="([^"]+)"/i);
  if (quoted) return quoted[1];
  const plain = value.match(/filename=([^;]+)/i);
  return plain ? plain[1].trim() : "electionmap-report.pdf";
}

async function parseErrorResponse(response) {
  try {
    const payload = await response.json();
    return {
      message: payload && typeof payload.error === "string" ? payload.error : `Export failed (${response.status})`,
      code: payload && typeof payload.code === "string" ? payload.code : "",
    };
  } catch (_) {
    return { message: `Export failed (${response.status})`, code: "" };
  }
}

function classifyError(status, code) {
  if (status === 401 || status === 403 || status === 400 || code === "validation_error" || code === "authorization_error") {
    return "validation";
  }
  return "runtime";
}

export async function requestReportPdf({ areaId, title, items }) {
  const response = await fetch("/api/reports/export-pdf", {
    method: "POST",
    credentials: "include",
    headers: {
      Accept: "application/pdf",
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      area_id: areaId,
      title,
      items,
    }),
  });

  if (!response.ok) {
    const errorPayload = await parseErrorResponse(response);
    throw new ReportExportError(errorPayload.message, {
      status: response.status,
      code: errorPayload.code || (response.status >= 500 ? "exporter_failure" : "validation_error"),
      kind: classifyError(response.status, errorPayload.code),
    });
  }

  const blob = await response.blob();
  return {
    blob,
    filename: getFilenameFromDisposition(response.headers.get("Content-Disposition")),
  };
}

export function downloadReportBlob(blob, filename = "electionmap-report.pdf") {
  const url = window.URL.createObjectURL(blob);
  const anchor = document.createElement("a");
  anchor.href = url;
  anchor.download = filename;
  document.body.appendChild(anchor);
  anchor.click();
  anchor.remove();
  window.URL.revokeObjectURL(url);
}
